
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'CombinationsStepInfo',
})
export default class CombinationsStepInfo extends Vue {
    @Prop({ type: String, default: '' }) private description!: string;

    private get formattedDescription(): string {
        // Replace newlines with <span> tags to maintain line breaks without extra spacing
        return this.description.replace(/\n/g, '<span class="no-space-break"></span>');
    }
}
